/*! Bisyou · Pop-up de entrada · leads → Martz (Captação Pop-up)
    Textos, imagens, cores e regras vêm da seção "Pop-up de entrada" (sections/bsy-popup.liquid). */
(function () {
  "use strict";
  if (window.__bsyPopupLoaded) return;
  window.__bsyPopupLoaded = true;

  var MARTZ_URL = "https://newsletters.martzapis.com.br/v1/subscribe";
  var KEY = "bsy_popup_v1";

  var BSY_CSS = "#bsy-pop{--bsy-marrom:#A77761;--bsy-creme:#F0F3E0;--bsy-cafe:#58433D;--bsy-terracota:#C84720;--bsy-rosa:#F8C0BC;--bsy-erro:#BC0039;--bsy-sans:\"Schibsted Grotesk\",system-ui,-apple-system,\"Segoe UI\",Roboto,Arial,sans-serif;--bsy-serif:\"Instrument Serif\",Georgia,\"Times New Roman\",serif;position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:16px;font-family:var(--bsy-sans);color:var(--bsy-cafe);-webkit-font-smoothing:antialiased;}#bsy-pop *,#bsy-pop *::before,#bsy-pop *::after{box-sizing:border-box;margin:0;padding:0}#bsy-pop.bsy-open{display:flex}#bsy-pop .bsy-overlay{position:absolute;inset:0;background:rgba(40,28,24,.58);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);opacity:0;transition:opacity .35s ease}#bsy-pop.bsy-in .bsy-overlay{opacity:1}#bsy-pop .bsy-modal{position:relative;width:min(880px,100%);max-height:calc(100vh - 32px);max-height:calc(100dvh - 32px);display:grid;grid-template-columns:44% 56%;background:var(--bsy-creme);border-radius:22px;overflow:hidden;box-shadow:0 30px 80px -20px rgba(40,28,24,.55);opacity:0;transform:translateY(14px) scale(.985);transition:opacity .4s ease,transform .45s cubic-bezier(.2,.8,.2,1);}#bsy-pop.bsy-in .bsy-modal{opacity:1;transform:none}#bsy-pop .bsy-media{position:relative;min-height:560px;background:#e9e4d8}#bsy-pop .bsy-media img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:var(--bsy-fp,50% 34%);display:block}#bsy-pop .bsy-media::after{content:\"\";position:absolute;inset:auto 0 0 0;height:38%;background:linear-gradient(to top,rgba(88,67,61,.55),rgba(88,67,61,0))}#bsy-pop .bsy-proof{position:absolute;left:18px;right:18px;bottom:18px;z-index:1;display:flex;align-items:center;gap:10px;padding:10px 14px;border-radius:14px;background:rgba(240,243,224,.16);border:1px solid rgba(240,243,224,.35);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--bsy-creme);font-size:13px;line-height:1.3}#bsy-pop .bsy-proof strong{font-weight:700}#bsy-pop .bsy-proof .bsy-stars{letter-spacing:1px;color:var(--bsy-rosa);font-size:13px;white-space:nowrap}#bsy-pop .bsy-body{position:relative;padding:44px 46px 30px;display:flex;flex-direction:column;overflow-y:auto}#bsy-pop .bsy-close{position:absolute;top:14px;right:14px;width:38px;height:38px;border-radius:50%;border:0;cursor:pointer;background:transparent;color:var(--bsy-cafe);display:grid;place-items:center;transition:background .2s;z-index:2}#bsy-pop .bsy-close:hover{background:rgba(167,119,97,.14)}#bsy-pop .bsy-close svg{width:18px;height:18px}#bsy-pop .bsy-brand{font-weight:800;font-size:22px;letter-spacing:-.5px;text-transform:lowercase;line-height:1}#bsy-pop .bsy-brand img{display:block;max-width:100%;height:auto}#bsy-pop .bsy-eyebrow{margin-top:26px;font-size:12px;font-weight:600;letter-spacing:2.6px;text-transform:uppercase;color:var(--bsy-marrom);display:flex;align-items:center;gap:10px}#bsy-pop .bsy-eyebrow::before{content:\"\";width:22px;height:1px;background:currentColor}#bsy-pop .bsy-title{margin-top:12px;font-weight:500;font-size:34px;line-height:1.08;letter-spacing:-1px}#bsy-pop .bsy-title em{font-family:var(--bsy-serif);font-style:italic;font-weight:400;font-size:1.16em;letter-spacing:0;color:var(--bsy-terracota)}#bsy-pop .bsy-title em{white-space:nowrap}#bsy-pop .bsy-sub{margin-top:12px;font-size:14.5px;line-height:1.5;opacity:.85;max-width:38ch}#bsy-pop form{margin-top:22px;display:flex;flex-direction:column;gap:10px}#bsy-pop .bsy-field{position:relative}#bsy-pop .bsy-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}#bsy-pop input[type=text],#bsy-pop input[type=email],#bsy-pop input[type=tel]{width:100%;height:50px;padding:0 16px;border-radius:12px;border:1px solid rgba(167,119,97,.45);background:rgba(255,255,255,.6);font:inherit;font-size:15px;color:var(--bsy-cafe);outline:none;transition:border-color .2s,box-shadow .2s,background .2s;-webkit-appearance:none;appearance:none}#bsy-pop input::placeholder{color:rgba(88,67,61,.55)}#bsy-pop input:focus{border-color:var(--bsy-marrom);background:#fff;box-shadow:0 0 0 4px rgba(167,119,97,.16)}#bsy-pop .bsy-field.bsy-err input{border-color:var(--bsy-erro);box-shadow:0 0 0 3px rgba(188,0,57,.1)}#bsy-pop .bsy-msg{display:none;font-size:12px;color:var(--bsy-erro);margin:5px 0 0 4px}#bsy-pop .bsy-err .bsy-msg{display:block}#bsy-pop .bsy-consent{display:flex;gap:10px;align-items:flex-start;margin-top:4px;font-size:12px;line-height:1.45;opacity:.85;cursor:pointer}#bsy-pop .bsy-consent input{flex:none;width:18px;height:18px;margin-top:1px;accent-color:var(--bsy-cafe);cursor:pointer}#bsy-pop .bsy-consent a{color:inherit;text-decoration:underline;text-underline-offset:2px}#bsy-pop .bsy-consent.bsy-err{color:var(--bsy-erro);opacity:1}#bsy-pop .bsy-btn{margin-top:6px;height:54px;border:0;border-radius:999px;cursor:pointer;background:var(--bsy-cafe);color:var(--bsy-creme);font:inherit;font-size:15px;font-weight:700;letter-spacing:.3px;display:flex;align-items:center;justify-content:center;gap:10px;transition:background .2s,transform .15s;text-decoration:none;width:100%}#bsy-pop .bsy-btn:hover{background:#45342f}#bsy-pop .bsy-btn:active{transform:scale(.99)}#bsy-pop .bsy-btn[disabled]{opacity:.7;cursor:wait}#bsy-pop .bsy-btn svg{width:18px;height:18px;transition:transform .2s}#bsy-pop .bsy-btn:hover svg{transform:translateX(3px)}#bsy-pop .bsy-btn.bsy-ghost{background:transparent;color:var(--bsy-cafe);border:1.5px solid var(--bsy-cafe)}#bsy-pop .bsy-btn.bsy-ghost:hover{background:rgba(88,67,61,.06)}#bsy-pop .bsy-spin{width:18px;height:18px;border-radius:50%;border:2px solid rgba(240,243,224,.35);border-top-color:var(--bsy-creme);animation:bsySpin .7s linear infinite}@keyframes bsySpin{to{transform:rotate(360deg)}}#bsy-pop .bsy-decline{display:block;width:max-content;margin:12px auto 0;text-align:center;background:none;border:0;font:inherit;font-size:13px;color:var(--bsy-cafe);opacity:.65;text-decoration:underline;text-underline-offset:3px;cursor:pointer}#bsy-pop .bsy-decline:hover{opacity:1}#bsy-pop .bsy-seals{margin-top:auto;padding-top:18px;display:flex;flex-wrap:wrap;gap:6px 16px;justify-content:center;font-size:11.5px;letter-spacing:.3px;opacity:.75}#bsy-pop .bsy-seals span{display:inline-flex;align-items:center;gap:6px}#bsy-pop .bsy-seals span::before{content:\"\";width:5px;height:5px;border-radius:50%;background:var(--bsy-marrom)}#bsy-pop .bsy-success{display:none;flex-direction:column;flex:1}#bsy-pop.bsy-done .bsy-form-step{display:none}#bsy-pop.bsy-done .bsy-success{display:flex;animation:bsyUp .5s cubic-bezier(.2,.8,.2,1)}@keyframes bsyUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}#bsy-pop .bsy-coupon{margin-top:22px;width:100%;height:auto;display:block;filter:drop-shadow(0 14px 22px rgba(88,67,61,.28))}#bsy-pop .bsy-copy{margin-top:16px}#bsy-pop .bsy-copy.bsy-copied{background:var(--bsy-marrom);border-color:var(--bsy-marrom);color:var(--bsy-creme)}#bsy-pop .bsy-applied{display:none;margin-top:12px;font-size:13px;align-items:center;gap:8px;justify-content:center;color:#2f6d64}#bsy-pop .bsy-applied.bsy-show{display:flex}#bsy-pop .bsy-applied svg{width:16px;height:16px}#bsy-pop .bsy-fine{margin-top:12px;font-size:11.5px;text-align:center;opacity:.7;line-height:1.4}@media (max-width:680px){#bsy-pop{padding:10px;align-items:flex-end}#bsy-pop .bsy-modal{grid-template-columns:1fr;grid-template-rows:auto minmax(0,1fr);border-radius:20px;max-height:calc(100vh - 20px);max-height:calc(100dvh - 20px)}#bsy-pop .bsy-media{min-height:0;width:100%;height:min(156px,46vw)}#bsy-pop .bsy-media img{object-position:50% 48%}#bsy-pop .bsy-media::after{display:none}#bsy-pop .bsy-proof{left:12px;right:auto;top:12px;bottom:auto;padding:6px 10px;font-size:11.5px;background:rgba(88,67,61,.6);border-color:rgba(240,243,224,.25)}#bsy-pop .bsy-proof .bsy-stars,#bsy-pop .bsy-proof-long{display:none}#bsy-pop .bsy-body{padding:18px 18px 14px}#bsy-pop .bsy-brand{display:none}#bsy-pop .bsy-eyebrow{margin-top:0;font-size:11px;letter-spacing:2.2px}#bsy-pop .bsy-title{margin-top:8px;font-size:25px;letter-spacing:-.6px}#bsy-pop .bsy-sub{font-size:13px;line-height:1.45;margin-top:6px}#bsy-pop form{margin-top:12px;gap:8px}#bsy-pop input[type=text],#bsy-pop input[type=email],#bsy-pop input[type=tel]{height:46px;font-size:16px;border-radius:11px}#bsy-pop .bsy-msg{margin-top:3px}#bsy-pop .bsy-consent{font-size:11.5px;line-height:1.4;margin-top:2px}#bsy-pop .bsy-btn{height:50px;margin-top:4px}#bsy-pop .bsy-close{top:10px;right:10px;width:34px;height:34px;background:rgba(240,243,224,.9)}#bsy-pop .bsy-seals{display:none}#bsy-pop .bsy-decline{margin-top:8px}#bsy-pop .bsy-coupon{margin-top:14px}#bsy-pop .bsy-copy{margin-top:12px}#bsy-pop .bsy-fine{margin-top:10px}#bsy-pop.bsy-done .bsy-media{height:120px}#bsy-pop.bsy-done .bsy-media img{object-position:50% 40%}}@media (max-width:680px) and (max-height:620px){#bsy-pop .bsy-media{height:100px}#bsy-pop .bsy-media img{object-position:50% 38%}#bsy-pop .bsy-proof{display:none}#bsy-pop .bsy-sub{display:none}#bsy-pop .bsy-title{font-size:23px}#bsy-pop.bsy-done .bsy-media{display:none}#bsy-pop.bsy-done .bsy-sub{display:none}}@media (max-height:640px) and (min-width:681px){#bsy-pop .bsy-media{min-height:0}#bsy-pop .bsy-body{padding-top:30px}}@media (prefers-reduced-motion:reduce){#bsy-pop .bsy-modal,#bsy-pop .bsy-overlay{transition:none}#bsy-pop.bsy-done .bsy-success{animation:none}}#bsy-pop .bsy-form-err{font-size:12.5px;line-height:1.4;color:var(--bsy-erro);text-align:center}#bsy-pop .bsy-form-err:empty{display:none}#bsy-pop .bsy-hp{position:absolute!important;left:-9999px!important;width:1px!important;height:1px!important;opacity:0!important}";
  var cfg = {}, root = null, form = null, lastFocus = null, opened = false, timer = null, exitHandler = null, keyHandler = null;

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(KEY) || "null");
      localStorage.setItem(KEY, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function track(event, extra) {
    if (cfg.designMode) return;
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: event, popup_id: "home_" + String(cfg.couponCode || "").toLowerCase() };
      for (var k in extra || {}) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  function shouldShow() {
    if (/[?&]bsy_popup=1/.test(location.search || "")) return true; // forçar: ?bsy_popup=1
    if (!cfg.enabled) return false;
    if (cfg.onlyHome && location.pathname !== "/") return false;
    if (cfg.hideForLoggedCustomers) {
      try {
        var cid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId) || (window.__st && __st.cid);
        if (cid) return false;
      } catch (e) {}
    }
    var s = store(true);
    if (s && s.status === "lead") return false;
    if (s && s.status === "closed" && Date.now() < s.until) return false;
    return true;
  }

  function injectAssets() {
    if (!document.querySelector("link[data-bsy-fonts]")) {
      var l = document.createElement("link");
      l.rel = "stylesheet"; l.setAttribute("data-bsy-fonts", "");
      l.href = "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@1&family=Schibsted+Grotesk:wght@400;500;600;700;800&display=swap";
      document.head.appendChild(l);
    }
    if (!document.querySelector("style[data-bsy-css]")) {
      var st = document.createElement("style");
      st.setAttribute("data-bsy-css", "");
      st.textContent = BSY_CSS;
      document.head.appendChild(st);
    }
  }

  function open(trigger) {
    if (opened || !root) return;
    opened = true;
    clearTimeout(timer);
    lastFocus = document.activeElement;
    root.classList.add("bsy-open");
    root.setAttribute("aria-hidden", "false");
    if (!cfg.designMode) document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (root) root.classList.add("bsy-in"); }); });
    if (!cfg.designMode) setTimeout(function () { var f = root && root.querySelector("#bsy-nome"); if (f && window.innerWidth > 680) f.focus({ preventScroll: true }); }, 420);
    track("bisyou_popup_view", { trigger: trigger });
  }

  function close(reason, instant) {
    if (!root) return;
    var el = root;
    opened = false;
    el.classList.remove("bsy-in");
    function hide() {
      el.classList.remove("bsy-open");
      el.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (!instant && lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (instant) hide(); else setTimeout(hide, 350);
    if (cfg.designMode || instant) return;
    if (!el.classList.contains("bsy-done")) {
      store(false, { status: "closed", until: Date.now() + (cfg.dismissDays || 7) * 864e5 });
      track("bisyou_popup_close", { reason: reason || "close" });
    }
  }

  function setErr(name, on) {
    var el = root.querySelector('[data-f="' + name + '"]');
    if (el) el.classList.toggle("bsy-err", on);
    return !on;
  }
  function validate() {
    var nome = form.nome.value.trim().replace(/\s+/g, " ");
    var email = form.email.value.trim().toLowerCase();
    var tel = form.whatsapp.value.replace(/\D/g, "");
    var ok = true;
    ok = setErr("nome", nome.length < 2) && ok;
    ok = setErr("email", !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) && ok;
    ok = setErr("whats", !/^[1-9][1-9]9\d{8}$/.test(tel)) && ok; // celular: DDD + 9 dígitos (padrão Martz)
    ok = setErr("consent", !form.consent.checked) && ok;
    return ok ? { nome: nome, email: email, tel: tel } : null;
  }

  function postMartz(payload) {
    return fetch(MARTZ_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r;
    });
  }
  function postWithRetry(payload) {
    return postMartz(payload).catch(function () {
      return new Promise(function (res) { setTimeout(res, 1500); }).then(function () { return postMartz(payload); });
    });
  }

  function bind() {
    var whats = root.querySelector("#bsy-whats");
    whats.addEventListener("input", function () {
      var d = whats.value.replace(/\D/g, "");
      if (d.length > 11 && d.indexOf("55") === 0) d = d.slice(2);
      d = d.slice(0, 11);
      var out = d;
      if (d.length > 2) out = "(" + d.slice(0, 2) + ") " + d.slice(2);
      if (d.length > 7) out = "(" + d.slice(0, 2) + ") " + d.slice(2, 7) + "-" + d.slice(7);
      whats.value = out;
    });

    ["nome", "email", "whatsapp"].forEach(function (n) {
      form[n].addEventListener("input", function () {
        var w = this.closest(".bsy-field"); if (w) w.classList.remove("bsy-err");
      });
    });
    form.consent.addEventListener("change", function () { setErr("consent", false); });
    Array.prototype.forEach.call(root.querySelectorAll(".bsy-consent a"), function (a) {
      a.target = "_blank"; a.rel = "noopener";
    });

    var formErr = root.querySelector(".bsy-form-err");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      formErr.textContent = "";
      var v = validate();
      if (!v) { var f = root.querySelector(".bsy-err input"); if (f) f.focus(); track("bisyou_popup_invalid"); return; }
      if (cfg.designMode) { success(v.nome.split(" ")[0]); return; }

      var btn = form.querySelector(".bsy-btn"), label = btn.innerHTML;
      if (btn.disabled) return;
      btn.disabled = true;
      btn.innerHTML = '<span class="bsy-spin"></span><span></span>';
      btn.lastChild.textContent = cfg.loadingLabel || "";

      // mesmo formato que o pop-up nativo da Martz envia
      var payload = {
        name: v.nome,
        page: location.href,
        email: v.email,
        phone: v.tel,
        "opt-in": true,
        document: null,
        honeypot: form.bsy_hp ? form.bsy_hp.value : "",
        birthdate: null,
        newsletter_id: cfg.martzNewsletterId
      };

      postWithRetry(payload).then(function () {
        btn.disabled = false; btn.innerHTML = label;
        var firstName = v.nome.split(" ")[0];
        try { document.dispatchEvent(new CustomEvent("bisyou:lead", { detail: { email: v.email, phone: v.tel } })); } catch (err) {}
        track("bisyou_popup_lead", { coupon: cfg.couponCode });
        success(firstName);
      }).catch(function (err) {
        btn.disabled = false; btn.innerHTML = label;
        formErr.textContent = cfg.errorMessage || "";
        track("bisyou_popup_error", { error: String(err && err.message || err) });
        if (window.console) console.warn("[Bisyou pop-up] falha ao enviar lead para a Martz", err);
      });
    });

    var copyBtn = root.querySelector(".bsy-copy"), copyLbl = root.querySelector(".bsy-copy-label");
    copyBtn.addEventListener("click", function () {
      var code = cfg.couponCode;
      function done() {
        copyBtn.classList.add("bsy-copied"); copyLbl.textContent = cfg.copiedLabel || code;
        track("bisyou_popup_copy", { coupon: code });
        setTimeout(function () { copyBtn.classList.remove("bsy-copied"); copyLbl.textContent = cfg.copyLabel; }, 2200);
      }
      function fallback() {
        var ta = document.createElement("textarea"); ta.value = code; ta.setAttribute("readonly", "");
        ta.style.position = "fixed"; ta.style.opacity = "0"; document.body.appendChild(ta); ta.select();
        try { document.execCommand("copy"); } catch (e) {} document.body.removeChild(ta); done();
      }
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
      else fallback();
    });

    var shop = root.querySelector(".bsy-shop");
    if (shop) shop.addEventListener("click", function () { track("bisyou_popup_shop_click"); });
    Array.prototype.forEach.call(root.querySelectorAll("[data-bsy-close]"), function (el) {
      el.addEventListener("click", function () { close(el.classList.contains("bsy-decline") ? "decline" : "close"); });
    });
  }

  function onKey(e) {
    if (!root || !root.classList.contains("bsy-open")) return;
    if (e.key === "Escape") close("esc");
    if (e.key === "Tab") {
      var f = Array.prototype.filter.call(root.querySelectorAll("button,a[href],input:not([tabindex='-1'])"), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function success(firstName) {
    firstName = (firstName || "").charAt(0).toUpperCase() + (firstName || "").slice(1).toLowerCase();
    var n = root.querySelector(".bsy-name");
    if (n) n.textContent = firstName ? ", " + firstName : "";
    root.classList.add("bsy-done");
    var bd = root.querySelector(".bsy-body"); if (bd) bd.scrollTop = 0;
    if (cfg.designMode) return;
    store(false, { status: "lead", at: Date.now() });
    var t = root.querySelector(".bsy-success .bsy-title");
    if (t) { t.setAttribute("tabindex", "-1"); t.focus({ preventScroll: true }); }
    if (cfg.autoApplyDiscount && cfg.couponCode && /^https?:$/.test(location.protocol)) {
      fetch("/discount/" + encodeURIComponent(cfg.couponCode), { credentials: "same-origin", redirect: "follow" })
        .then(function (r) { if (r.ok) root.querySelector(".bsy-applied").classList.add("bsy-show"); })
        .catch(function () {});
    }
  }

  function teardown() {
    clearTimeout(timer);
    if (exitHandler) document.removeEventListener("mouseout", exitHandler);
    exitHandler = null;
    if (root) close("api", true);
    root = form = null;
    opened = false;
  }

  function setup(openNow) {
    root = document.getElementById("bsy-pop");
    if (!root) return;
    try { cfg = JSON.parse(root.querySelector("[data-bsy-config]").textContent); } catch (e) { cfg = {}; }
    injectAssets();
    form = root.querySelector("form");
    bind();
    if (cfg.designMode) {
      if (cfg.previewStep === "success") success("Maria");
      if (openNow) open("editor");
      return;
    }
    if (!shouldShow()) return;
    timer = setTimeout(function () { open("delay"); }, cfg.delayMs || 0);
    if (cfg.exitIntent && window.matchMedia && window.matchMedia("(pointer:fine)").matches) {
      exitHandler = function (e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener("mouseout", exitHandler); exitHandler = null; open("exit_intent"); }
      };
      document.addEventListener("mouseout", exitHandler);
    }
  }

  function isMine(e) { return root && e.detail && e.detail.sectionId === root.getAttribute("data-section-id"); }

  function init() {
    window.BisyouPopup = {
      open: function () { open("manual"); },
      close: function () { close("api"); },
      reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
    };
    document.addEventListener("keydown", onKey);
    setup(false);

    // Editor de tema: abre ao selecionar a seção, fecha ao sair, recarrega ao editar
    if (window.Shopify && Shopify.designMode) {
      var selected = false;
      document.addEventListener("shopify:section:select", function (e) { if (isMine(e)) { selected = true; open("editor"); } });
      document.addEventListener("shopify:section:deselect", function (e) { if (isMine(e)) { selected = false; close("api", true); } });
      document.addEventListener("shopify:section:unload", function (e) {
        if (root && e.target && e.target.contains(root)) teardown();
      });
      document.addEventListener("shopify:section:load", function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector("#bsy-pop")) { teardown(); setup(selected); }
      });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
